import { render, staticRenderFns } from "./UsersListAdminTable.vue?vue&type=template&id=542acf78&"
import script from "./UsersListAdminTable.vue?vue&type=script&lang=js&"
export * from "./UsersListAdminTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports